var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "bg-light" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3 col-12 p-0 text-small" },
          [
            _vm.jobUser
              ? _c("section", { staticClass: "px-2" }, [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("div", { staticClass: "mb-3" }, [
                          _c("img", {
                            staticClass: "rounded-circle",
                            attrs: {
                              src: _vm.jobUser.picture,
                              alt: "",
                              width: "64"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl-3" }, [
                          _c("ul", { staticClass: "list-unstyled" }, [
                            _c("li", [
                              _c("h3", {
                                staticClass: "m-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getUserType(_vm.jobUser)
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("h3", { staticClass: "m-0 py-2" }, [
                                _vm.jobUser.prefix_name
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.jobUser.prefix_name))
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.jobUser.name) +
                                    "\n                      "
                                ),
                                _vm.jobUser.birth_date
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.getUserAge()) + " ปี")
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "text-small text-secondary" },
                              [
                                _vm.jobUser.tel
                                  ? _c(
                                      "span",
                                      { staticClass: "d-inline-block pr-2" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-phone text-primary"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.jobUser.tel) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.jobUser.address_province &&
                                _vm.jobUser.district
                                  ? _c(
                                      "span",
                                      { staticClass: "d-inline-block pr-2" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-map-marker-alt -status-alert"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.jobUser.address_province
                                                .name_th
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm.jobUser.district.name_th
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("แนะนำตัว")]),
                            _vm._v(":"),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.jobUser.introduce) + " ")
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("ประสบการณ์ทำงาน")]),
                            _vm._v(":"),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.jobUser.working_experience) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("สถานภาพ")]),
                            _vm._v(": "),
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.jobUser.marital_status) + " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("ทักษะขับรถยนต์")]),
                            _vm._v(": "),
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.jobUser.driving_car) + " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("ทักษะขับมอเตอร์ไซค์")]),
                            _vm._v(": "),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.jobUser.driving_motorcycle) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("p", [
                            _c("b", [_vm._v("โรคประจำตัว")]),
                            _vm._v(": "),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.jobUser.disease) + " ")
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("h3", { staticClass: "mb-2" }, [
                            _vm._v("ทักษะของฉัน")
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "pl-3",
                              staticStyle: { "line-height": "1.75rem" }
                            },
                            [
                              _vm._l(_vm.jobSkills, function(jobSkill, index) {
                                return [
                                  _vm.hasSkill(jobSkill.id)
                                    ? _c("li", { key: index }, [
                                        _vm._v(_vm._s(jobSkill.name))
                                      ])
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("h3", { staticClass: "mb-2" }, [
                            _vm._v("ภาษาที่ฉันสื่อสารได้")
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "pl-3",
                              staticStyle: { "line-height": "1.75rem" }
                            },
                            [
                              _vm._l(_vm.jobLanguages, function(
                                jobLanguage,
                                index
                              ) {
                                return [
                                  _vm.hasLanguage(jobLanguage.id)
                                    ? _c("li", { key: index }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              jobLanguage.name === "Thai"
                                                ? jobLanguage.native
                                                : jobLanguage.name
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block btn-outline-info",
                            on: {
                              click: function($event) {
                                return _vm.showModal()
                              }
                            }
                          },
                          [_vm._v("แก้ไขข้อมูล")]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("toggle-button", {
                              attrs: {
                                value: _vm.jobUser.allow_notification === 1,
                                color: "#FFC107"
                              },
                              on: { change: _vm.updateAllowNotification }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pb-4" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block btn-lg btn-light bg-white border shadow-sm",
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [_vm._m(1)]
                    )
                  ])
                ])
              : _c("section", { staticClass: "px-2" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h2", { staticClass: "text-center" }, [
                        _vm._v("มีบัญชีกับ BeNeat Jobs หรือยัง?")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _vm.apiUrl
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-success btn-lg",
                                attrs: { href: _vm.apiUrl }
                              },
                              [
                                _vm._m(2),
                                _vm._v(
                                  "  ล็อคอิน/ลงทะเบียน BeNeat Jobs ผ่าน LINE\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isDevelopment()
                          ? _c("div", { staticClass: "pt-3 text-left" }, [
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "lineId" } }, [
                                  _vm._v("Line User Id (for testing)")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.lineUserId,
                                      expression: "lineUserId"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", id: "lineId" },
                                  domProps: { value: _vm.lineUserId },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.lineUserId = $event.target.value
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-info btn-block",
                                  on: {
                                    click: function($event) {
                                      return _vm.testLoginJobUser()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Login\n                "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("update-profile-modal", { ref: "updateProfileModal" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-fill" }, [
      _c("label", { staticClass: "m-0" }, [
        _vm._v("ให้ระบบแจ้งเตือนงานที่ตรงกับคุณสมบัติของฉันไปที่ Line")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-secondary text-small" }, [
      _c("i", { staticClass: "fas fa-sign-out-alt" }),
      _vm._v(" ออกจากระบบ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "d-inline-block pl-2" }, [
      _c("i", { staticClass: "fab fa-line fa-lg" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0450f616", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0450f616","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/JobUser.vue
// module id = 2214
// module chunks = 0